import {
  GridModalFormProps,
  UseFormReturnType,
  Validator,
  globalMessageHandler,
  useForm,
} from "common";
import { useParams } from "common/components/Form/ParamsContext";
import I18n from "i18n";
import { Params } from "react-router-dom";
import {
  ReviewPartnerItem,
  ReviewPartnerOptions,
  getReviewPartnerService,
} from "./reviewPartnerApi";

export interface UseReviewPartnerFormProps extends GridModalFormProps {}

type RouteParams = {
  review_partner_id?: string;
};

export interface UseReviewPartnerFormReturnType
  extends UseFormReturnType<ReviewPartnerItem, ReviewPartnerOptions> {
  params?: Readonly<Params<"review_partner_id">>;
}

export default function useReviewPartnerForm({
  id,
  afterSave,
  defaultValues,
}: UseReviewPartnerFormProps): UseReviewPartnerFormReturnType {
  const params = useParams<"review_partner_id">();
  const scope = undefined;
  const service = getReviewPartnerService(scope);

  const form = useForm<ReviewPartnerItem, ReviewPartnerOptions>({
    id: params.review_partner_id || id,
    ignoreNavigateAfterCreate: true,
    translationCategory: "ReviewPartner",
    rules: {
      name: Validator.rule.any().required(),
    },
    afterSave,
    defaultValues,
    onValidationFailed: () => {
      globalMessageHandler.snack({
        severity: "error",
        message: I18n.t("App.formHasErrors"),
      });
    },
    ...service,
    loadOptions: undefined,
  });

  return { ...form, params };
}
